import { Box, Typography } from '@mui/material';
import ContainerBox from 'components/ContainerBox';
import React from 'react';
import { useTranslation } from 'services/localization';
import Stripe from './Stripe';

type ThirdPartyProvidersProps = {
	rentlePaymentsSupported: boolean;
};

const ThirdPartyProviders = (props: ThirdPartyProvidersProps) => {
	const { rentlePaymentsSupported } = props;
	const { t } = useTranslation();
	return (
		<ContainerBox>
			{rentlePaymentsSupported && (
				<Box mb={3}>
					<Typography variant="h5">
						{t('account.payments.thirdPartyProviders', 'Third-party providers')}
					</Typography>
					<Typography variant="body2" color="textSecondary">
						{t(
							'account.payments.thirdPartyProvidersDescription',
							'External payment methods and third-party providers',
						)}
					</Typography>
				</Box>
			)}
			<Stripe
				rentlePaymentsSupported={rentlePaymentsSupported}
				styles={{
					titleVariant: rentlePaymentsSupported ? 'h6' : 'h5',
					buttonVariant: rentlePaymentsSupported ? 'outlined' : 'contained',
				}}
			/>
		</ContainerBox>
	);
};

export default ThirdPartyProviders;
